import IMask from "imask";

export default class Gateways {
  constructor() {
    this.setDocumentMask();
    this.handlerPersonType();
    this.setDocumentNameAttribute();
    this.hideGateway();
    this.setFingerPrintEnviroment();
    this.hideBlockDocumentField();
    this.selectedGateway();
  }
  

  hideBlockDocumentField() {
    const person = document.querySelector(
      "#vindi-pagamentos__billing_persontype",
    );

    if (person) {
      person.addEventListener("change", () => {
        if (person.value == 2) {
          this.handlerDocumentField(false);
        } else {
          this.handlerDocumentField(true);
        }
      });
    }
  }

  setFingerPrintEnviroment() {
    const enviroment = document.querySelector(".wvp-enviroment");
    const elements = document.querySelectorAll(".wvp-fingerprint");

    if (window.yapay && enviroment) {
      const fingerprint = window.yapay.FingerPrint({
        env: enviroment.value,
      });

      elements.forEach((element) => {
        element.value = fingerprint.getFingerPrint();
      });
    }
  }

  setDocumentMask() {
    const documents = document.querySelectorAll(".wc-vindi-customer-document");
    documents.forEach((element) => {
      if (element.classList.contains("wvp-block-field")) {
        IMask(element, {
          mask: "000.000.000-00",
        });
      }
    });
  }

  handlerPersonType() {
    const person = document.querySelector("#billing_persontype");

    if (person) {
      this.handlerDocumentField(person.value === "1");

      jQuery("#billing_persontype").change(() => {
        this.handlerDocumentField(person.value === "1");
      });
    }
  }

  handlerDocumentField(show) {
    const documents = document.querySelectorAll(
      ".vindi-pagamentos-document",
    );
    documents.forEach((element) => {
      if (show) {
        element.classList.add("vindi-pagamentos-document-hidden");
      } else {
        element.classList.remove("vindi-pagamentos-document-hidden");
      }
    });
  }

  setDocumentNameAttribute() {
    const documents = document.querySelectorAll(".wc-vindi-customer-document");

    documents.forEach((element) => {
      element.addEventListener("focusin", () => {
        this.unsetDocumentNameAttribute();

        element.setAttribute("name", "wc-vindi-customer-document");
      });
    });
  }

  unsetDocumentNameAttribute() {
    const documents = document.querySelectorAll(".wc-vindi-customer-document");

    documents.forEach((element) => {
      element.removeAttribute("name");
    });
  }

  hideGateway() {
    const hiddens = document.querySelectorAll(".wvp-hidden-gateway");

    hiddens.forEach((hidden) => {
      const gateway = document.querySelector(`.payment_method_${hidden.value}`);
      if (gateway) {
        gateway.classList.add("wvp-hidden-gateway");
      } else {
        this.hideBlockGateways(hidden);
      }
    });
  }

  hideBlockGateways(gateway) {
    const input = document.querySelector(`#hidden-${gateway.value}`);
    if (input) {
      const parent = input.parentElement.parentElement;
      parent.classList.add("wvp-hidden-gateway");
    }
  }

  selectedGateway() {
    const gateways = document.querySelectorAll('form.checkout input[name^="payment_method"]');
    gateways.forEach(gateway => {
      gateway.addEventListener('change', () => {
        const event = new Event('update_checkout');
        document.body.dispatchEvent(event)
      });
    });
  }

}
